import { Button, CircularProgress } from '@mui/material';
import { Field } from 'formik';
import { TextField } from 'formik-mui';
import React from 'react';

type EnrollProps = {
  disabled: boolean;
  sendCode: () => void;
};

const EnrollForm: React.FC<EnrollProps> = ({ disabled, sendCode }) => {
  return (
    <>
      <Field
        component={TextField}
        required
        fullWidth
        margin="normal"
        label="Phone"
        type="tel"
        id="phone"
        name="phone"
        disabled={disabled}
      />
      <Button
        type="button"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        disabled={disabled}
        onClick={sendCode}
      >
        {disabled ? <CircularProgress size={24} /> : `Enroll Phone Number`}
      </Button>
    </>
  );
};

export default EnrollForm;
